import { fetchSupBooking, bookingCount, getTrips } from '../../pages/supBooking/supBookingFun/fetchSupBookings';
import fetchTripDates from '../../pages/supBooking/supBookingFun/fetchTripDates';
import { getOrganizers } from '../getOrganizers';

const commonBaseAPIServiceConfig = {
    fetchOrg: ({ serviceType, setOrgData, setLoading }) => {
        return getOrganizers(serviceType, setOrgData, setLoading);
    },
    fetchBookingData: ({
        limit,
        setBookings,
        setStats,
        setLoading,
        offSet,
        selectedOrg,
        selectedTrip,
        selectedDate,
        selectedType,
        datesType,
        group,
        serviceType
    }) => {
        return fetchSupBooking(
            limit,
            setBookings,
            setStats,
            setLoading,
            offSet,
            selectedOrg,
            selectedTrip,
            selectedDate,
            selectedType,
            datesType,
            group,
            serviceType
        );
    },
    fetchTrips: ({ selectedOrg, setTrips, datesType, group, setLoading, serviceType }) => {
        return getTrips(selectedOrg, setTrips, datesType, group, setLoading, serviceType);
    },
    fetchBookingCount: ({
        setTotalCount,
        setLoading,
        selectedOrg,
        selectedTrip,
        selectedDate,
        selectedType,
        datesType,
        group,
        serviceType
    }) => {
        return bookingCount(
            setTotalCount,
            setLoading,
            selectedOrg,
            selectedTrip,
            selectedDate,
            selectedType,
            datesType,
            group,
            serviceType
        );
    }
};

export const supBookingsServiceConfig = {
    trip: {
        fetchOrg: ({ serviceType, setOrgData, setLoading }) => {
            return getOrganizers(serviceType, setOrgData, setLoading);
        },
        fetchBookingData: ({
            limit,
            setBookings,
            setStats,
            setLoading,
            offSet,
            selectedOrg,
            selectedTrip,
            selectedDate,
            selectedType,
            datesType,
            group,
            serviceType
        }) => {
            return fetchSupBooking(
                limit,
                setBookings,
                setStats,
                setLoading,
                offSet,
                selectedOrg,
                selectedTrip,
                selectedDate,
                selectedType,
                datesType,
                group,
                serviceType
            );
        },
        fetchTrips: ({ selectedOrg, setTrips, datesType, group, setLoading, serviceType }) => {
            return getTrips(selectedOrg, setTrips, datesType, group, setLoading, serviceType);
        },
        fetchTripDates: ({ selectedTrip, setTripDates, selectedType, setLoading }) => {
            return fetchTripDates(selectedTrip, setTripDates, selectedType, setLoading);
        },
        fetchBookingCount: ({
            setTotalCount,
            setLoading,
            selectedOrg,
            selectedTrip,
            selectedDate,
            selectedType,
            datesType,
            group,
            serviceType
        }) => {
            return bookingCount(
                setTotalCount,
                setLoading,
                selectedOrg,
                selectedTrip,
                selectedDate,
                selectedType,
                datesType,
                group,
                serviceType
            );
        }
    },
    gu: commonBaseAPIServiceConfig,
    act: commonBaseAPIServiceConfig,
    camp: commonBaseAPIServiceConfig
};
